export const formatURL = (str: string): string => {
  if (str.startsWith('https') || str.startsWith('http')) {
    return str;
  }

  const pathname = str.startsWith('/') ? str : `/${str}`;
  return `${window.location.origin}${pathname}`;
};
